import React, {useRef, useState, useEffect} from 'react'
import { DndProvider, useDragDropManager } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DragSource, DropArea } from './compound-components'
import { CustomDragLayer } from './compound-components/CustomDragLayer'
import { DragAndDropContextProvider } from './hooks/useDragAndDropContext'

const DragAndDrop = (props) => {


  const {
    children,
    dndProps = {},
    config = {},
    disabled,
    style
  } = props;

  const {
    actions = {},
    customDragLayer = false, 
    allowSort = false,
    onLimitReachedHover = ()=>false,
    source,
    target,
    unplacedHolder
  } = config

  // const customDragLayer = useRef(defaultCustomDragLayer)
  // const allowSort = useRef(defaultAllowSort)

  const dispatch = (action) => {
    console.log(action)
    switch (action.type){
      default:
        if (actions[action.type]) actions[action.type](...action.package)
        break
    }
  }
 



  return (

    <DndProvider backend={HTML5Backend}>
      <DragAndDropContextProvider value={{ customDragLayer, allowSort, onLimitReachedHover, dndProps, disabled, source, target, unplacedHolder, style, dispatch}}>
        {children}
      </DragAndDropContextProvider>
      {customDragLayer && <CustomDragLayer/>}
    </DndProvider>

  )

}

DragAndDrop.DragSource = DragSource
DragAndDrop.DropArea = DropArea


export default DragAndDrop